<template>
  <div class="page">
    <img class="policyPos" :src="kaola1" alt="" />
    <img class="policyPos" :src="kaola2" alt="" />
    <img class="policyPos" :src="kaola3" alt="" />
    <img class="policyPos" :src="kaola4" alt="" />
    <img class="policyPos" :src="kaola5" alt="" />
    <img class="policyPos" :src="kaola6" alt="" />
    <img class="policyPos" :src="kaola7" alt="" />
    <img class="policyPos" :src="kaola8" alt="" />
    <img class="policyPos" :src="kaola9" alt="" />
    <img class="policyPos" :src="kaola10" alt="" />

    <a @click="goAppoint()"><div class="btngo">预约试驾</div></a>
  </div>
</template>
<script>
import dataServer from "@/api/data";
export default {
  data() {
    return {
      kaola1: require("../assets/images/kaolaDetail/01@2x.png"),
      kaola2: require("../assets/images/kaolaDetail/02@2x.png"),
      kaola3: require("../assets/images/kaolaDetail/03@2x.png"),
      kaola4: require("../assets/images/kaolaDetail/04@2x.png"),
      kaola5: require("../assets/images/kaolaDetail/05@2x.png"),
      kaola6: require("../assets/images/kaolaDetail/06@2x.png"),
      kaola7: require("../assets/images/kaolaDetail/07@2x.png"),
      kaola8: require("../assets/images/kaolaDetail/08@2x.png"),
      kaola9: require("../assets/images/kaolaDetail/09@2x.png"),
      kaola10: require("../assets/images/kaolaDetail/10@2x.png"),
      mobile: "",
      platform: "",
      ccbParamSJ: "",
    };
  },
  created() {
    console.log("url:", window.location.href);
    this.getUrlParams();
  },
  mounted() {
    document.documentElement.style.height = "auto";
    document.body.style.height = "auto";
  },
  methods: {
    getUserInfo(val) {
      dataServer.getCCBDecrypt({ ciphertext: val }).then((res) => {
        console.log(res);
        if (res.status === "SUCCEED") {
          this.mobile = res.data.mobile;
        }
      });
    },
    getUrlParams() {
      let query = window.location.search.substring(1);
      let vars = query.split("&");
      for (let i = 0; i < vars.length; i++) {
        let pair = vars[i].split("=");
        if (pair[0] == "ccbParamSJ") {
          this.ccbParamSJ = pair[1];
          console.log("ccbParamSJ:", this.ccbParamSJ);
          this.getUserInfo(this.ccbParamSJ);
        }
      }
      return;
    },
    goAppoint() {
      console.log(
        "/appointDrive?colorMode=darkMode&platform=CCB_APP&vehicleModel=KAOLA&mobile=" +
          this.mobile
      );
      this.$router.push({
        path:
          "/appointDrive?colorMode=darkMode&platform=CCB_APP&vehicleModel=KAOLA&mobile=" +
          this.mobile,
      });
    },
  },
};
</script>
<style lang="scss">
.page {
  padding: 0 !important;
}

.darkMode .content {
  color: #7e7e7f !important;
}
.policyPos {
  width: 100%;
}

.btngo {
  position: fixed;
  display: block;
  width: 3.2rem;
  height: 0.4rem;
  bottom: 0.5rem;
  left: 50%;
  margin-left: -1.6rem;
  border-radius: 0.06rem;
  color: #fff;
  line-height: 0.4rem;
  font-size: 0.18rem;
  text-align: center;
  background-color: #4798cb !important;
  img {
    width: 100%;
  }
}
</style>
